import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-worker-statuses-container', {
    whiteSpace: 'nowrap',
    minHeight: '37px',
    lineHeight: '37px',
});

cssRule('.tb-worker-statuses-container .tb-data-grid-icon', {
    display: 'inline-block',
    paddingRight: '3px',
});

cssRule('.tb-worker-statuses-container .tb-data-grid-icon .tb-icon-process-status', {
    height: 'inherit',
});

cssRule('.tb-worker-statuses-container .tb-process-preferred-label', {
    paddingLeft: '2px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
});

cssRule('.tb-server-status-grid-container .tb-data-grid-separator-row', {
    verticalAlign: 'top',
});

cssRule('.tb-status-controls-container', {
    width: '508px',
    position: 'relative',
    paddingTop: '6px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-status-legend', {
    marginLeft: '35px',
    height: '23px',
    lineHeight: '23px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-status-legend-item-label', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-ziplog-date-col', {
    width: '165px',
});

cssRule('.tb-ziplog-size-col', {
    width: '70px',
});

